import React, { Component } from "react";
import { Icon } from "semantic-ui-react";
import { getAppConfig } from "config/client.config";

export class ListingMenuHeader extends Component {
    render() {
        let isPortrait = window.innerHeight > window.innerWidth;
        let title = {
            position: "relative",
            margin: isPortrait ? "5px 0" : "15px 0",
            fontSize: getAppConfig().inductor ? "1.1em" : ""
        };
        let circle = {
            position: "absolute",
            width: "2em",
            height: "2em",
            top: "0.25em",
            left: "0.5em",
            background: "#ffb82f",
            borderRadius: "50%",
        };

        let badgeStyle = {
            marginLeft: "11px",
            background: getAppConfig().colors.accents.secondary,
            color: getAppConfig().colors.accents.secondaryText,
            top: "2px",
            width: "26px",
            position: "absolute",
            borderRadius: "50%",
            fontSize: "0.8em",
            right: "3px",
            textAlign: "center",
            height: "26px"
        };

        return (
            <h3 style={title}>
                <div style={circle} />
                <div
                    style={{
                        position: "relative",
                    }}
                >
                    <Icon
                        name={
                            this.props.icon == null
                                ? "columns"
                                : this.props.icon
                        }
                        size="big"
                    />{" "}
                    {this.props.title == null ||
                        this.props.title === "NULLS" ||
                        this.props.title.length < 3
                        ? "CONTENT CATEGORIES"
                        : this.props.title === "search"
                            ? "SEARCH RESULTS"
                            : this.props.title}

                    {this.props.format === "notifications" &&
                        <div
                            style={badgeStyle}
                        >
                            {this.props.notification ? this.props.notification.unreadNotification : this.props.unreadCount}
                        </div>
                    }
                </div>
            </h3>
        );
    }
}
